import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme } from '@mui/material';
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { inicializarCapturaErroresFrontend } from "./services/frontendErrorLogger";
import ErrorBoundary from "./components/common/ErrorBoundary";

// Captura de errores no controlados de JavaScript y promesas en el navegador
inicializarCapturaErroresFrontend();

const themeFont = createTheme({
  typography: {
    fontFamily: 'Tahoma',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
